import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-[#FAF8F5]">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-sm' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center">
            <img src="https://static.readdy.ai/image/c5866e26fdbc96711840c633abff697c/c1835d69db7fabaf75d95c928971d977.png" alt="Touchborn Logo" className="h-12 w-auto" />
          </div>
          <div className="hidden md:flex items-center gap-8">
            <a href="#videos" className={`text-sm font-light transition-colors ${scrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-gray-200'}`}>Eğitim Videoları</a>
            <a href="#exercises" className={`text-sm font-light transition-colors ${scrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-gray-200'}`}>Egzersizler</a>
            <a href="#articles" className={`text-sm font-light transition-colors ${scrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-gray-200'}`}>Uzman Makaleleri</a>
            <a href="#breathing" className={`text-sm font-light transition-colors ${scrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-gray-200'}`}>Nefes Teknikleri</a>
            <a href="#about" className={`text-sm font-light transition-colors ${scrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-gray-200'}`}>Hakkımızda</a>
          </div>
          <button className="bg-[#FFB5A7] text-gray-800 px-6 py-2.5 rounded-full text-sm font-medium hover:bg-[#FFA094] transition-colors whitespace-nowrap">
            Ücretsiz Dene
          </button>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative h-screen flex items-center">
        <div className="absolute inset-0">
          <img 
            src="https://public.readdy.ai/ai/img_res/9ed45f601957d9afa5fabebfdb3455b2.jpg" 
            alt="Hero Background" 
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-6 w-full">
          <div className="max-w-2xl">
            <h1 className="text-6xl md:text-7xl font-extrabold text-white mb-6 leading-tight">
              Doğal Doğuma<br />Hazırlık Yolculuğunuz
            </h1>
            <p className="text-xl text-white font-light mb-8 max-w-xl leading-relaxed">
              Pelvis egzersizleri, nefes teknikleri ve psikodrama ile doğumun derinliklerine yolculuk
            </p>
            <button className="bg-[#2C2C2C] text-white px-8 py-4 rounded-full flex items-center gap-4 hover:bg-[#1a1a1a] transition-colors group whitespace-nowrap">
              <div className="w-10 h-10 bg-[#FF6B35] rounded-full flex items-center justify-center">
                <i className="ri-play-fill text-white text-xl"></i>
              </div>
              <span className="font-medium">Videolara Başla</span>
              <i className="ri-arrow-right-up-line text-xl group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"></i>
            </button>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-24 bg-[#FAF8F5]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="mb-12">
            <p className="text-sm text-gray-500 font-light mb-3">Touchborn Farkı</p>
            <h2 className="text-5xl md:text-6xl font-extrabold text-[#2C2C2C] mb-2">
              Doğumun
            </h2>
            <h2 className="text-5xl md:text-6xl font-serif italic text-[#2C2C2C]">
              Derinliklerine
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-[#FFB5A7] rounded-3xl p-10 relative">
              <div className="absolute top-8 right-8 w-12 h-12 bg-white rounded-full flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-2xl text-[#2C2C2C]"></i>
              </div>
              <div className="text-7xl font-serif font-bold text-white mb-4">%95</div>
              <p className="text-lg font-medium text-[#2C2C2C] mb-2">Doğal doğum başarı oranı</p>
              <p className="text-sm text-[#2C2C2C]/80 mb-6">Eğitim tamamlayan annelerde</p>
              <p className="text-xl font-serif italic text-[#2C2C2C]">Güvenle doğuruyorlar</p>
            </div>

            <div className="bg-[#E8D5F2] rounded-3xl p-10 relative">
              <div className="absolute top-8 right-8 w-12 h-12 bg-white rounded-full flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-2xl text-[#2C2C2C]"></i>
              </div>
              <div className="text-7xl font-serif font-bold text-white mb-4">%100</div>
              <p className="text-base text-[#2C2C2C] leading-relaxed">
                Uzman psikodrama terapistleri ve fizyoterapistler eşliğinde kişiselleştirilmiş doğum hazırlığı
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Training Videos Section */}
      <section id="videos" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="mb-12">
            <p className="text-sm text-gray-500 font-light mb-3">Günlük Eğitimler</p>
            <h2 className="text-5xl md:text-6xl font-extrabold text-[#2C2C2C]">
              Kişisel Video<br />Eğitim Programı
            </h2>
          </div>

          <div className="grid md:grid-cols-4 gap-6">
            {[
              { title: 'Pelvis Açma Egzersizleri', duration: '12 dk', bg: '#FFE5E5', image: 'Pregnant woman doing pelvic floor exercises on yoga mat, gentle stretching movements, soft pink studio background, wellness and fitness concept, professional training photography, warm lighting, simple minimalist setting' },
              { title: 'Nefes Teknikleri Temelleri', duration: '15 dk', bg: '#D4F1E8', image: 'Pregnant woman practicing breathing exercises in meditation pose, calm and peaceful expression, mint green studio background, mindfulness and relaxation concept, professional wellness photography, soft natural light' },
              { title: 'Doğum Pozisyonları', duration: '18 dk', bg: '#F0F0F0', image: 'Pregnant woman demonstrating natural birth positions with exercise ball, supportive postures, neutral gray studio background, birth preparation concept, professional instructional photography, clean and modern' },
              { title: 'Rahatlama Meditasyonu', duration: '20 dk', bg: '#F5E6D3', image: 'Pregnant woman in deep meditation and relaxation pose, serene peaceful atmosphere, warm beige studio background, mindfulness and calm concept, professional wellness photography, soft golden lighting' }
            ].map((video, index) => (
              <div key={index} className="rounded-3xl overflow-hidden shadow-sm hover:shadow-lg transition-shadow cursor-pointer group">
                <div className="relative h-80" style={{ backgroundColor: video.bg }}>
                  <img 
                    src={`https://readdy.ai/api/search-image?query=$%7Bvideo.image%7D&width=400&height=500&seq=video-${index}&orientation=portrait`}
                    alt={video.title}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors flex items-center justify-center">
                    <div className="w-16 h-16 bg-white/90 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                      <i className="ri-play-fill text-3xl text-[#2C2C2C]"></i>
                    </div>
                  </div>
                </div>
                <div className="bg-white p-5">
                  <h3 className="font-semibold text-[#2C2C2C] mb-2 text-base">{video.title}</h3>
                  <p className="text-sm text-gray-500">{video.duration}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Interactive Exercises Section */}
      <section id="exercises" className="py-24 bg-[#FAF8F5]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="mb-12">
            <p className="text-sm text-gray-500 font-light mb-3">İnteraktif Deneyim</p>
            <h2 className="text-5xl md:text-6xl font-extrabold text-[#2C2C2C]">
              Rehberli Egzersiz<br />Programları
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white rounded-2xl p-10 hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 mb-6 flex items-center justify-center">
                <i className="ri-lungs-line text-5xl text-[#2C2C2C]"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#2C2C2C] mb-4">Nefes Teknikleri</h3>
              <p className="text-gray-600 leading-relaxed">
                Doğum sırasında kullanabileceğiniz kanıtlanmış nefes egzersizleri ve meditasyon teknikleri
              </p>
            </div>

            <div className="bg-white rounded-2xl p-10 hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 mb-6 flex items-center justify-center">
                <i className="ri-body-scan-line text-5xl text-[#2C2C2C]"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#2C2C2C] mb-4">Pelvis Güçlendirme</h3>
              <p className="text-gray-600 leading-relaxed">
                Doğuma hazırlık için özel tasarlanmış pelvis açma ve güçlendirme hareketleri
              </p>
            </div>

            <div className="bg-white rounded-2xl p-10 hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 mb-6 flex items-center justify-center">
                <i className="ri-emotion-line text-5xl text-[#2C2C2C]"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#2C2C2C] mb-4">Psikodrama Seansları</h3>
              <p className="text-gray-600 leading-relaxed">
                Doğum korkularınızı aşmak için uzman eşliğinde grup ve bireysel psikodrama çalışmaları
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Expert Articles CTA */}
      <section id="articles" className="relative h-screen flex items-center justify-center">
        <div className="absolute inset-0">
          <img 
            src="https://readdy.ai/api/search-image?query=Peaceful%20pregnant%20woman%20in%20nature%20outdoor%20setting%2C%20soft%20morning%20golden%20hour%20light%2C%20natural%20landscape%20background%2C%20serene%20and%20calm%20atmosphere%2C%20wellness%20and%20natural%20birth%20concept%2C%20professional%20lifestyle%20photography%2C%20warm%20earth%20tones%2C%20gentle%20sunlight&width=1920&height=1080&seq=articles-bg&orientation=landscape"
            alt="Articles Background"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-black/35"></div>
        </div>

        <div className="relative text-center px-6">
          <h2 className="text-6xl md:text-7xl font-extrabold text-white mb-8 tracking-wider">
            UZMAN BİLGİSİ
          </h2>
          <p className="text-xl text-white font-light mb-12 max-w-2xl mx-auto leading-relaxed">
            Doğum uzmanları, fizyoterapistler ve<br />psikodrama terapistlerinden güncel makaleler
          </p>
          <button className="bg-[#2C2C2C] text-white px-8 py-4 rounded-full inline-flex items-center gap-4 hover:bg-[#1a1a1a] transition-colors group whitespace-nowrap">
            <div className="w-10 h-10 bg-[#FF6B35] rounded-full flex items-center justify-center">
              <i className="ri-book-open-line text-white text-xl"></i>
            </div>
            <span className="font-medium tracking-wide">MAKALELERİ KEŞFET</span>
            <i className="ri-arrow-right-up-line text-xl group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"></i>
          </button>
        </div>
      </section>

      {/* Breathing Exercises Section */}
      <section id="breathing" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="mb-12 text-center">
            <p className="text-sm text-gray-500 font-light mb-3">Özel Teknikler</p>
            <h2 className="text-5xl md:text-6xl font-extrabold text-[#2C2C2C]">
              Nefes Egzersizleri
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {[
              { title: 'Derin Karın Nefesi', desc: 'Doğum ağrılarını yönetmek için temel teknik', icon: 'ri-heart-pulse-line' },
              { title: 'Ritmik Nefes', desc: 'Kasılmalar sırasında rahatlama sağlar', icon: 'ri-rhythm-line' },
              { title: 'Görselleştirme Nefesi', desc: 'Zihinsel odaklanma ve sakinlik', icon: 'ri-eye-line' },
              { title: 'Partner Nefesi', desc: 'Eşinizle birlikte uygulayabileceğiniz teknikler', icon: 'ri-parent-line' },
              { title: 'Ses ile Nefes', desc: 'Doğal ses çıkararak rahatlama', icon: 'ri-music-2-line' },
              { title: 'Pozisyon Nefesi', desc: 'Farklı doğum pozisyonlarında nefes kontrolü', icon: 'ri-compass-3-line' }
            ].map((item, index) => (
              <div key={index} className="bg-[#FAF8F5] rounded-2xl p-8 hover:shadow-md transition-shadow cursor-pointer group">
                <div className="w-14 h-14 bg-[#E8D5F2] rounded-full flex items-center justify-center mb-5 group-hover:bg-[#FFB5A7] transition-colors">
                  <i className={`${item.icon} text-3xl text-[#2C2C2C]`}></i>
                </div>
                <h3 className="text-xl font-bold text-[#2C2C2C] mb-3">{item.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonial Section */}
      <section className="py-24 bg-[#FAF8F5]">
        <div className="max-w-6xl mx-auto px-6">
          <div className="bg-[#2C2C2C] rounded-3xl overflow-hidden flex flex-col md:flex-row items-center">
            <div className="md:w-1/3 relative">
              <img 
                src="https://readdy.ai/api/search-image?query=Happy%20new%20mother%20holding%20newborn%20baby%20with%20joyful%20smile%2C%20natural%20birth%20success%20story%2C%20warm%20and%20loving%20atmosphere%2C%20professional%20portrait%20photography%2C%20soft%20natural%20lighting%2C%20emotional%20and%20heartwarming%20moment&width=400&height=600&seq=testimonial&orientation=portrait"
                alt="Testimonial"
                className="w-full h-96 md:h-full object-cover object-top rounded-2xl md:rounded-none md:-ml-8 md:my-8"
              />
            </div>
            <div className="md:w-2/3 p-12 md:p-16">
              <div className="text-6xl text-[#F5E6D3] mb-6">"</div>
              <p className="text-white text-xl md:text-2xl leading-relaxed mb-8">
                Touchborn programı sayesinde doğal doğum yapma cesaretini buldum. Pelvis egzersizleri ve nefes teknikleri doğum sırasında inanılmaz yardımcı oldu.
              </p>
              <div className="mb-8">
                <p className="text-white font-semibold text-lg">Ayşe Yılmaz</p>
                <p className="text-white/70 text-sm">2 çocuk annesi, Doğal doğum</p>
              </div>
              <button className="bg-[#FFB5A7] text-[#2C2C2C] px-8 py-3 rounded-full font-medium hover:bg-[#FFA094] transition-colors whitespace-nowrap">
                Tüm Hikayeleri Oku
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#1a1a1a] text-white py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-3 gap-12 mb-12">
            <div>
              <h3 className="text-4xl font-bold mb-6">touchborn</h3>
              <p className="text-white/70 leading-relaxed mb-8 max-w-sm">
                Doğal doğuma hazırlık yolculuğunuzda yanınızdayız. Uzman eğitmenler eşliğinde güvenli ve bilinçli bir doğum deneyimi.
              </p>
              <div className="flex gap-4">
                <a href="#" className="w-10 h-10 border border-white/30 rounded-full flex items-center justify-center hover:bg-white/10 transition-colors">
                  <i className="ri-instagram-line text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 border border-white/30 rounded-full flex items-center justify-center hover:bg-white/10 transition-colors">
                  <i className="ri-facebook-fill text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 border border-white/30 rounded-full flex items-center justify-center hover:bg-white/10 transition-colors">
                  <i className="ri-youtube-fill text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 border border-white/30 rounded-full flex items-center justify-center hover:bg-white/10 transition-colors">
                  <i className="ri-twitter-x-line text-lg"></i>
                </a>
              </div>
            </div>

            <div>
              <div className="mb-6">
                <h4 className="text-xs font-semibold text-white/50 mb-2 tracking-wider">ADRES</h4>
                <p className="text-white/80 text-sm">Nispetiye Cad. No:12<br />Etiler, İstanbul</p>
              </div>
              <div className="mb-6">
                <h4 className="text-xs font-semibold text-white/50 mb-2 tracking-wider">TELEFON</h4>
                <p className="text-white/80 text-sm">+90 212 555 0123</p>
              </div>
              <div>
                <h4 className="text-xs font-semibold text-white/50 mb-2 tracking-wider">E-POSTA</h4>
                <p className="text-white/80 text-sm">info@touchborn.com</p>
              </div>
            </div>

            <div className="flex justify-end">
              <img 
                src="https://readdy.ai/api/search-image?query=Joyful%20mother%20with%20newborn%20baby%20in%20loving%20embrace%2C%20happiness%20and%20bonding%20moment%2C%20natural%20birth%20success%2C%20professional%20portrait%20photography%2C%20warm%20and%20emotional%20atmosphere%2C%20soft%20natural%20lighting&width=400&height=500&seq=footer-img&orientation=portrait"
                alt="Footer"
                className="w-64 h-80 object-cover object-top rounded-2xl"
              />
            </div>
          </div>

          <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/60 text-sm">© 2025 Touchborn. Tüm hakları saklıdır.</p>
            <div className="flex gap-6 text-sm text-white/60">
              <a href="#" className="hover:text-white transition-colors">Gizlilik Politikası</a>
              <a href="#" className="hover:text-white transition-colors">Kullanım Koşulları</a>
              <a href="#" className="hover:text-white transition-colors">Çerezler</a>
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Powered by Readdy</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
